const isEveryQuerySuccess = (...queries) =>
  queries.every((query) => query.isSuccess && !query.isLoading)

export default isEveryQuerySuccess
